import { setting } from "../core-nextv3/util/setting";

const platform = {
    id    : "hlvsk9bS",
    label : "E-commerce",
    value : "ecommerce"
}

const THEME_SETTING : any = {
    accountName                 : "Veria",
    showSizeVariants            : true,
    showPixDiscount             : true,
    showProductInterest         : false,
    pixDiscount                 : 5,
    disabledDisplayColorVatiant : true,
    disabledFilterSize          : true,	
    widthLogo                   : 110,
    heightLogo                  : 19,
    widthProductThumb           : 683,
    heightProductThumb          : 1024,
    imageCDN                   	: true,
    disabeldInputRegister       : true,
    disabledFotoCategoryMobile  : true,
    disabledExpress             : true,
    maxParcel                   : 6, 
    minValue                    : 40,
    disabledInfiniteScroll     	: true,
    revalidate                  : 60 * 60 * 1,
    registrationLoginTypeForm   : "CPF",
    domainFrom                 	: "https://storage.googleapis.com/veria-fde5b.appspot.com",
    domainTo                   	: "https://images.veria.com.br",
    productPath                 : "/produtos/",
    cookieConsent          	    : "Olá cliente Veria, utilizamos cookies com fins analíticos e para mostrar anúncios relacionados a suas preferências. Para mais informações visite a nossa <a href=\"/loja/privacidade-e-seguranca\" style={{ fontSize: \"14px\" }}>Política de Privacidade</a>",
    footerInfo         	        : ` <p>© 2023 Todos os Direitos Reservados</p>
	<p>CAMELIA CONFECCOES DE MODAS LTDA - CNPJ: 41.783.385/0001-98</p>
	<p>São Paulo - SP, CEP:01125-001</p>`,
};

const MENU_HEADER_STATIC = [
    {
        label : "Sobre Nós",
        url   : "/loja/sobre-nos"
    },
    // {
    // 	label : 'Dúvidas',
    // 	url : '/loja/duvidas',
    // 	children : [
    // 		{
    // 			label : 'Guia de tamanho',
    // 			url : '/loja/guia-de-tamanho',
    // 		},
    // 		{
    // 			label : 'Devolução',
    // 			url : '/loja/devolucao',
    // 		},
    // 		{
    // 			label : 'Pagamento e Envio',
    // 			url : '/loja/pagamento-e-envio',
    // 		},
    // 		{
    // 			label : 'Privacidade e Segurança',
    // 			url : '/loja/privacidade-e-seguranca'
    // 		}
    // 	]
    // },
    // {
    // 	label : 'Rastrear Pedido',
    // 	url : '/loja/rastrear-pedido',
    // }
]

const parseSizeVariant = (label:string) =>
{
    return label.split(" / ")[0];
}

// MENU FOOTER
const MENU_FOOTER_STATIC = [ {
    label    : "Institucional",
    url      : "/loja/sobre-nos",
    children : [
        {
            label : "Sobre Nós",
            url   : "/loja/sobre-nos/",
        },
        {
            label : "Perguntas Frequentes",
            url   : "/loja/perguntas-frequentes/",
        },
        {
            label : "Nossas Avaliações",
            url   : "/avaliacoes/",
        } ]
} ];

const MENU_FOOTER_STATIC_TWO = [ {
    label    : "Minha Conta",
    url      : "/loja/minha-conta",
    children : [ {
        label : "Meus Pedidos",
        url   : "/perfil/",
    },
    {
        label : "Cadastrar",
        url   : "/cadastro/",
    } ]
}, 
{
    label    : "AJUDA",
    url      : "/loja/ajuda",
    children : [
        {
            label : "Troca e Devolução",
            url   : "/loja/troca-e-devolucao/",
        },
        {
            label : "Privacidade e Segurança",
            url   : "/loja/privacidade-e-seguranca/",
        },
        {
            label : "Pagamentos e Entregas",
            url   : "/loja/pagamentos-e-entregas/",
        } ]
} ]

// ACCOUNT
const ACCOUNT_SETTING = setting({
    accid    : "default",
    appid    : "accounts",
    colid    : "documents",    
    platform : platform,
    map      : true,
    mapItems : {
        referencePath : "default/accounts/grids/5vTO1pyeQ1DrUjtmzOTx",
    },    
});

// AUTH
const AUTH_SETTING = setting({
    accid    : "default",
    appid    : "users",
    colid    : "documents",
    platform : platform,
    form     : {
        referencePath : "default/users/forms/5BMnB6DwQDHZ0ir8zatM",
    },
    map      : true,
    mapItems : {
	  	referencePath : "default/users/grids/AoCSINcZsgY9IPEFUkWg",
    },	
});

//PAGE
const PAGE_SETTING = setting({
    accid    : "default",
    appid    : "page",
    colid    : "documents",
    platform : platform,
    map      : true,
    mapItems : {
        referencePath : "default/page/grids/iBqwfjj1mYhVKHRnUuTn",
    },
});

// TROCA PAGE
const TROCA_PAGE_SETTING = PAGE_SETTING.merge(
    {
        document : {
            referencePath : "default/page/documents/HP1sNyqv7m5aWMcags67",
        },
    });

// SELLER PAGE
const SELLER_PAGE_SETTING = PAGE_SETTING.merge(
    {
        document : {
            referencePath : "default/page/documents/QHLD25xPnrfnkWs8lgCC",
        },
    });

// SELLER CONTACT
const SELLER_CONTACT_SETTING = setting({
    accid    : "default",
    appid    : "contactSeller",
    colid    : "documents",
    platform : platform,
    form     : {
        referencePath : "default/contactSeller/forms/8gOrScHMaNA0Gg6FVBYN",
    },
    map      : true,
    mapItems : {
	  	referencePath : "default/contactSeller/grids/Q7Nm2jHzfessE7Hx0W4O",
    },	
});

// MENU
const MENU_SETTING = setting({
    accid    : "default",
    appid    : "menuEcom",
    colid    : "documentsMenu",
    platform : platform,
    orderBy  : "order",
    map      : true,
    mapItems : {
	  	referencePath : "default/menuEcom/grids/dqLTDidonpYYJHQbxzUf",
    },
});

//HOME PAGE
const HOME_PAGE_SETTING = setting({
    accid    : "default",
    appid    : "page",
    colid    : "documents",
    platform : platform,
    map      : true,
    mapItems : {
        referencePath : "default/page/grids/yRP915cQD7mknZnQfaTR",
    },
    stockName : {
        referencePath : "default/stockName/documents/H7ny9BhRSF6jj1KsfeDW",
    },
    priceName : {
        referencePath : "default/priceName/documents/IHB4sw0sMlKnyipukzBl",
    },
    id : "x7QfWZRN8FUuJM4OtlaN",
});

//FEATURES PRODUCTS
const FEATURES_PRODUCTS_SETTING = setting({
    accid    : "default",
    appid    : "page",
    colid    : "documents",
    platform : platform,
    map      : true,
    mapItems : {
        referencePath : "default/page/grids/D4V0jcTeY8n8XnK8XdFa",
    },
    document : {
        referencePath : "default/page/documents/d8xzjdlfzk74QHJ9l76a",
    }
});

//CART
const CART_SETTING = setting({
    accid    : "default",
    appid    : "cart",
    colid    : "documents",
    platform : platform,
    map      : true,
    form     : {
        referencePath : "default/cart/forms/yi8sxDEbExlshNIXREV3",
    },
    mapItems : {
        referencePath : "default/cart/grids/wMiMTuZOe9Bq6Z7Z9pDz",
    },
    stockName : {
        referencePath : "default/stockName/documents/H7ny9BhRSF6jj1KsfeDW",
    },
    priceName : {
        referencePath : "default/priceName/documents/IHB4sw0sMlKnyipukzBl",
    },
});

//SLUG PRODUCT
const SLUG_PRODUCT_SETTING = setting({
    accid    : "default",
    appid    : "product",
    colid    : "documents",
    level    : 1,
    map      : true,
    asc      : false,
    orderBy  : "postdate",
    mapItems : {
        referencePath : "default/product/grids/KDITs2CX8HKvsZ2tr58B",
    },
});

//FULL PRODUCT
const FULL_PRODUCT_SETTING = setting({
    accid     : "default",
    appid     : "product",
    colid     : "documents",
    level     : 1,
    map       : true,
    asc       : false,
    orderBy   : "postdate",
    stockName : {
        referencePath : "default/stockName/documents/H7ny9BhRSF6jj1KsfeDW",
    },
    priceName : {
        referencePath : "default/priceName/documents/IHB4sw0sMlKnyipukzBl",
    },
    mapItems : {
        referencePath : "default/product/grids/ZUnonLswnK67KE4lnDmg",
    },
});

//TOPHEADER
const TOP_HEADER_PAGE_SETTING = setting({
    id       : "ZOvWTyOaNqLFdDJ3MvIp",
    accid    : "default",
    appid    : "page",
    colid    : "documents",
    platform : platform,
    map      : true,
    mapItems : {
        referencePath : "default/page/grids/uORRtH39mWoINxzVm2k2",
    },
});

//FOOTER
const FOOTER_PAGE_SETTING = setting({
    id       : "3KVC7EuP77MzR4MDjFpO",
    accid    : "default",
    appid    : "page",
    colid    : "documents",
    platform : platform,
    map      : true,
    mapItems : {
        referencePath : "default/page/grids/OehR6S7QIrL9RU2T60FR",
    },
});

const PARTIAL_PRODUCT_VARIANT_SETTING = setting({
    accid     : "default",
    appid     : "productsVariant",
    colid     : "documentsProductsVariant",
    perPage   : 24,
    map       : true,
    asc       : false,
    orderBy   : "postdate",
    stockName : {
        referencePath : "default/stockName/documents/H7ny9BhRSF6jj1KsfeDW",
    },
    priceName : {
        referencePath : "default/priceName/documents/IHB4sw0sMlKnyipukzBl",
    },
    mapItems : {
        referencePath : "default/productsVariant/grids/ZcmwVS3S0mCF3rz4krXe",
    },
});

//COLOR VARIANT
const COLOR_VARIANT_SETTING = setting({
    accid    : "default",
    appid    : "variant",
    colid    : "documents",
    platform : platform,
    map      : true,
    mapItems : {
        referencePath : "default/variant/grids/8fK0IK1Lfo5Jg0gEIG2T",
    },
    document : {
        referencePath : "default/variant/documents/LQ7n5VZ77ssTwNnfvx4l",		
    }
});

//SIZE VARIANT
const SIZE_VARIANT_SETTING = setting({
    accid    : "default",
    appid    : "variant",
    colid    : "documents",
    platform : platform,
    map      : true,
    mapItems : {
        referencePath : "default/variant/grids/8fK0IK1Lfo5Jg0gEIG2T",
    },
    document : {
        referencePath : "default/variant/documents/ToPsCD1W8453TdFmi2OJ",		
    }
});

// COLOR TABLE
const COLOR_TABLE_SETTING = setting({
    accid    : "default",
    appid    : "colorTable",
    colid    : "documentsColorTable",
    platform : platform,
    map      : true,
    mapItems : {
        referencePath : "default/colorTable/grids/mkv5zqiiE0tDO2pYiLsQ",
    },
    document : {
        referencePath : "default/colorTable/documentsColorTable/X34DSa3vivx6tAM5kUsM",
    },
});

// FAVORITE
const FAVORITE_SETTING = setting({
    accid    : "default",
    appid    : "favorite",
    colid    : "documents",
    level    : 1,
    platform : platform,
    form     : {
	  	referencePath : "default/favorite/forms/ghuUb5rkraNVu4o3JfCm",
    },	
    map      : true,
    mapItems : {
	  	referencePath : "default/favorite/grids/Acg4mXIZyUBv8FOYdUuI",
    },		
    stockName : {
        referencePath : "default/stockName/documents/H7ny9BhRSF6jj1KsfeDW",
    },
    priceName : {
        referencePath : "default/priceName/documents/IHB4sw0sMlKnyipukzBl",
    },
});

const GIFT_PAGE_SETTING = setting({
    accid    : "default",
    appid    : "page",
    colid    : "documents",
    platform : platform,
    map      : true,
    document : {
        referencePath : "default/page/documents/tKnzIvkMVrbz0eakkdWM"
    },
    mapItems : {
        referencePath : "default/page/grids/PZhgu4pI8VCpmfEiplED",
    },		
    stockName : {
        referencePath : "default/stockName/documents/H7ny9BhRSF6jj1KsfeDW",
    },
    priceName : {
        referencePath : "default/priceName/documents/IHB4sw0sMlKnyipukzBl",
    },
});

// CATEGORY
const CATEGORY_SETTING = setting({
    accid    : "default",
    appid    : "category",
    colid    : "documents",
    platform : platform,
    orderBy  : "name",
    map      : true,
    mapItems : {
        referencePath : "default/category/grids/6diDjwiaSnSRWAsxwiL8",
    },
});

const SLUG_CATEGORY_SETTING = setting({
    accid    : "default",
    appid    : "category",
    colid    : "documents",
    platform : platform,
    orderBy  : "name",
    map      : true,
    mapItems : {
	  	referencePath : "default/category/grids/aCDBBWPiKheOPVYHAAmM",
    },
});

// COLLECTION
const COLLECTION_SETTING = setting({
    accid    : "default",
    appid    : "collection",
    colid    : "documentsCollection",
    platform : platform,
    orderBy  : "order",
    map      : true,
    level    : 1,
    mapItems : {
	  	referencePath : "default/collection/grids/JZW16zn9jC6lvpvcFqze",
    }
});

const SLUG_COLLECTION_SETTING = setting({
    accid    : "default",
    appid    : "collection",
    colid    : "documentsCollection",
    platform : platform,
    orderBy  : "order",
    map      : true,
    level    : 1,
    mapItems : {
	  	referencePath : "default/collection/grids/pmLOGyNNcBXgZmdxpfaA",
    },
    stockName : {
        referencePath : "default/stockName/documents/H7ny9BhRSF6jj1KsfeDW",
    },
    priceName : {
        referencePath : "default/priceName/documents/IHB4sw0sMlKnyipukzBl",
    },
});

// ANALYTICS
const ANALYTICS_SETTING = setting({
    accid    : "default",
    appid    : "analytics",
    colid    : "documents",
    platform : platform,
    form     : {
	  	referencePath : "default/analytics/forms/Ug7kc4pRJaVLiZFouS96",
    },	
    map      : true,
    mapItems : {
	  	referencePath : "default/analytics/grids/dFcRzAsbqUnF1WgDGS9T",
    },		
});

// SHIPPING
const SHIPPING_SETTING = setting({
    accid    : "default",
    appid    : "shippings",
    colid    : "documents",
    platform : platform,
});

// PAYMENT METHODS OPTION
const PAYMENT_METHODS_OPTION_SETTING = setting({
    accid  	 : "default",
    appid  	 : "option",
    colid  	 : "documents",
    platform : platform,	
    document : {
        referencePath : "default/option/documents/kdEtgv8BEwVRju3W5gmD",
  	},
    map      : true,
    mapItems : {
	  	referencePath : "default/option/grids/eOSSt7GuN91qGN0sV97l",
    },	
});

// TRACK
const TRACK_SETTING = setting({
    accid    : "default",
    appid    : "shippings",
    colid    : "documentsShippings",
    platform : platform,
    shipping : {
        referencePath : "default/shippings/documentsShippings/ufwveF9ivZgeK3Iq98Yw"
    },
    mapItems : {
        referencePath : "default/accounts/grids/BkjMWCLOWO35yX0mOGq0",
    }
});

//ORDER
const ORDER_SETTING = setting({
    accid    : "default",
    appid    : "financial",
    colid    : "documents",
    platform : platform,
    map      : true,
    orderBy  : "postdate",
    asc      : false,
    form     : {
        referencePath : "default/financial/forms/yBwJpLgkPRGiJcjVlz4r",
    },
    mapItems : {
        referencePath : "default/financial/grids/Pxn8ESNxcjMqviSVw7KN",
    },	
    stockName : {
        referencePath : "default/stockName/documents/H7ny9BhRSF6jj1KsfeDW",
    },
    priceName : {
        referencePath : "default/priceName/documents/IHB4sw0sMlKnyipukzBl",
    },
});

//GATEWAY
const GATEWAY_SETTING = setting({
    accid    : "default",
    appid    : "gateway",
    colid    : "documents",
    platform : platform,
    document : {
	  referencePath : "default/gateway/documents/F2JEy0TFZjhd63XOCosX",
    },
    mapItems : {
        referencePath : "default/gateway/grids/lt5qhYTpjvB6lTBqHllS",
    },	
});

//FULL VIDEOS
const FULL_VIDEOS_SETTING = setting({
    accid    : "default",
    appid    : "video",
    colid    : "documents",
    platform : platform,
    map      : true,
    mapItems : {
        referencePath : "default/video/grids/dbeU1yrbKfNNMPP8R5J1",
    },
    stockName : {
        referencePath : "default/stockName/documents/H7ny9BhRSF6jj1KsfeDW",
    },
    priceName : {
        referencePath : "default/priceName/documents/IHB4sw0sMlKnyipukzBl",
    },
});

//SLUG VIDEO
const SLUG_VIDEO_SETTING = setting({
    accid    : "default",
    appid    : "video",
    colid    : "documents",
    platform : platform,
    map      : true,
    orderBy  : "postdate",
    asc      : false,
    mapItems : {
        referencePath : "default/video/grids/m5MiLBJ0OTOC7XrxloTI",
    },
});

//TRACK BACK
const STATUS_BAR_PAGE_SETTING = setting({
    accid    : "default",
    appid    : "page",
    colid    : "documents",
    platform : platform,
    map      : true,
    mapItems : {
        referencePath : "default/page/grids/I7dudEVw2qJWCjEY6V0M",
    },
    document : {
        referencePath : "default/page/documents/Tup1pi6l3uW4bCAXHc2B"
    }
});

//POPUP PRODUCT PAGE
const POPUP_PAGE_SETTING = setting({
    accid    : "default",
    appid    : "page",
    colid    : "documents",
    platform : platform,
    map      : true,
    mapItems : {
        referencePath : "default/page/grids/rqCznmlzJAMwa50XsNdr",
    },
    document : {
        referencePath : "default/page/documents/naxJCLzkQYpsbnhxbI9j"
    }
});

// PAGE PIX
const COUNTDOWN_PAGE_SETTING = setting({
    accid    : "default",
    appid    : "page",
    colid    : "documents",
    platform : platform,
    map      : true,
    mapItems : {
        referencePath : "default/page/grids/zKGtPhWWoCzPyjJLZVTs",
    },
    document : {
        referencePath : "default/page/documents/AfhBQOdJCLofii14QH4v",
    },
});

//REORDER
const REORDER_SETTING = setting({
    accid         : "default",
    appid         : "reorder",
    colid         : "documents",
    platform      : platform,
    map           : true,
    orderBy       : "postdate",
    asc           : false,
    ownerField    : "client",
    reorderAmount : 1,
    form          : {
        referencePath : "default/reorder/forms/H8Y34pKpwr2Be83hmiYY",
    },
    mapItems : {
        referencePath : "default/reorder/grids/64aAGCx9iuJrgVr9jphf",
    }
});

const REORDER_INFO : any = {
    name         			: "Solicitar Devolução",
    labelNoteClient : "Motivo da Devolução",
    disabledReason  : true,
};

// OPTION
const OPTION_SETTING = setting({
    accid  	 : "default",
    appid  	 : "option",
    colid  	 : "documents",
    platform : platform,	
    map      : true,
    mapItems : {
	  	referencePath : "default/option/grids/eOSSt7GuN91qGN0sV97l",
    },	
});

const REORDER_TYPE_OPTION = OPTION_SETTING.merge({
    id : "ziG6VTye0Y9zCAfTjLBj"
})

const REASONS_REORDER_OPTION = OPTION_SETTING.merge({
    id : "idPG6M3pVTTn3LFgPope"
});

//COMMET
const COMMET_SETTING = setting({
    accid    : "default",
    appid    : "comment",
    colid    : "documents",
    platform : platform,
    orderBy  : "postdate",
    asc      : false,
    map      : true,
    mapItems : {
        referencePath : "default/comment/grids/UNVPd4ZDWeqwdZ0qtkZY",
    },
    form : {
        referencePath : "default/comment/forms/RUHBFkTuTsKGOiVBbbVr",
    },
});

const NEWS_PAGE_SETTING = setting({});
const ORDER_PAGE_SETTING = setting({});
const REORDER_PAGE_SETTING = setting({});
const SIGN_PAGE_SETTING = setting({});
const ORDER_EXPRESS_SETTING = setting({});
const PAGE_SELLER_SETTING = setting({});
const STORAGE_SETTING = setting({});
const RESELLER_SETTING = setting({});
const COUPON_SETTING = setting({});
const SELLET_SETTING = setting({});
const CUSTOM_EVENTS_PAGE_SETTING = setting({});
const APIS_MAP = null;

export {
    platform,
    THEME_SETTING, 
    APIS_MAP,
    NEWS_PAGE_SETTING,
    parseSizeVariant,
    GATEWAY_SETTING,
    MENU_HEADER_STATIC,
    MENU_FOOTER_STATIC,
    MENU_FOOTER_STATIC_TWO,
    CUSTOM_EVENTS_PAGE_SETTING,
    ACCOUNT_SETTING,
    AUTH_SETTING,
    PAGE_SETTING,
    MENU_SETTING,
    HOME_PAGE_SETTING,
    FEATURES_PRODUCTS_SETTING,
    CART_SETTING,
    SLUG_PRODUCT_SETTING,
    FULL_PRODUCT_SETTING,
    TOP_HEADER_PAGE_SETTING,
    PARTIAL_PRODUCT_VARIANT_SETTING,
    COLOR_VARIANT_SETTING,
    SIZE_VARIANT_SETTING,
    COLOR_TABLE_SETTING,
    FAVORITE_SETTING,
    GIFT_PAGE_SETTING,
    CATEGORY_SETTING,
    SLUG_CATEGORY_SETTING,
    ANALYTICS_SETTING,
    SHIPPING_SETTING,
    PAYMENT_METHODS_OPTION_SETTING,
    ORDER_SETTING,
    COLLECTION_SETTING,
    SLUG_COLLECTION_SETTING,
    TROCA_PAGE_SETTING,
    SELLER_PAGE_SETTING,
    SELLER_CONTACT_SETTING,
    FULL_VIDEOS_SETTING,
    SLUG_VIDEO_SETTING,
    STATUS_BAR_PAGE_SETTING,
    POPUP_PAGE_SETTING,
    COUNTDOWN_PAGE_SETTING,
    REORDER_SETTING,
    REORDER_INFO,
    REORDER_TYPE_OPTION,
    OPTION_SETTING,
    REASONS_REORDER_OPTION,
    TRACK_SETTING,
    COMMET_SETTING,
    FOOTER_PAGE_SETTING,
    ORDER_PAGE_SETTING,
    SIGN_PAGE_SETTING,
    ORDER_EXPRESS_SETTING,
    PAGE_SELLER_SETTING,
    STORAGE_SETTING,
    RESELLER_SETTING,
    REORDER_PAGE_SETTING,
    COUPON_SETTING,
    SELLET_SETTING,
}